import React from 'react'
import { Bullet } from 'components/atoms/icons'
import PropTypes from 'prop-types'
import { ManagerTag } from 'transfix-ui/components/ManagerTag'
import { CarrierPopover } from 'apps/booking/components/CarrierPopover/CarrierPopover'
import { NotAvailableIcon } from 'transfix-icons'
import { formatCurrency } from 'utils/formatCurrency'
import { formatPhone } from 'utils/formatPhone'
import { RelativeTimeBubble } from './RelativeTimeBubble'

const ContactPhoneExt = React.memo(({ ext }) => {
  if (ext) return <span className='text-secondary'> ext {ext}</span>
  return null
})

const SimilarLaneLinkSDR = React.memo(({ activeRowId, shipmentId }) => {
  if (shipmentId !== activeRowId) {
    return (
      <span className='text-secondary'>
        Same lane and pickup date <Bullet /> Added for{' '}
        <a href={`${__ROOT__}/shipment-details/${shipmentId}?tab=scheduling`}>#{shipmentId}</a>
      </span>
    )
  }
  return null
})

export const TableRow = React.memo(props => {
  const {
    activeRowId,
    amount,
    carrierApplicationId,
    carrierApplicationName,
    carrierApplicationState,
    carrierContactName,
    carrierContactPhone,
    carrierContactPhoneExt,
    createdAt,
    createdByName,
    declinedAt,
    shipmentId,
    source,
    updatedAt,
  } = props
  return (
    <div className='row'>
      <div className='col-lg-1'>
        {declinedAt ? (
          <NotAvailableIcon color='coolGray5' />
        ) : (
          <RelativeTimeBubble date={updatedAt || createdAt} />
        )}
      </div>
      <div className='col-lg-10'>
        {carrierApplicationId && (
          <CarrierPopover
            id={carrierApplicationId}
            legalName={carrierApplicationName || `ID: #${carrierApplicationId}`}
            status={carrierApplicationState}
          />
        )}
        {!carrierApplicationId && <p className='text-secondary'>Carrier was not entered</p>}
        <p>
          {formatCurrency(amount, true)}
          <Bullet />
          {formatPhone(carrierContactPhone)}
          <ContactPhoneExt ext={carrierContactPhoneExt} />
          {source === 'manual' ? (
            <>
              {carrierContactName && <Bullet />}
              {carrierContactName}
            </>
          ) : (
            <>
              <Bullet /> Bid by {createdByName}
            </>
          )}
        </p>
        <SimilarLaneLinkSDR shipmentId={shipmentId} activeRowId={activeRowId} />
      </div>
      <div className='col-lg-1'>
        <ManagerTag type='creator' align='right' fullName={createdByName} />
      </div>
    </div>
  )
})

ContactPhoneExt.propTypes = { ext: PropTypes.string }
ContactPhoneExt.defaultProps = { ext: null }

TableRow.propTypes = {
  updatedAt: PropTypes.string,
  createdAt: PropTypes.string,
  declinedAt: PropTypes.string,
  carrierApplicationId: PropTypes.number,
  carrierApplicationName: PropTypes.string,
  carrierContactPhone: PropTypes.string,
  carrierContactPhoneExt: PropTypes.string,
  carrierApplicationState: PropTypes.string,
  amount: PropTypes.string,
  createdByName: PropTypes.string,
  carrierContactName: PropTypes.string,
  source: PropTypes.string,
  shipmentId: PropTypes.number,
  activeRowId: PropTypes.number,
}
TableRow.defaultProps = {
  updatedAt: '',
  createdAt: '',
  declinedAt: null,
  carrierApplicationId: 0,
  carrierApplicationName: '',
  carrierContactPhone: '',
  carrierContactPhoneExt: null,
  carrierApplicationState: '',
  amount: '',
  createdByName: '',
  carrierContactName: '',
  source: '',
  shipmentId: null,
  activeRowId: null,
}
